<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
    <div class="bg-card flex min-w-0 flex-auto flex-col dark:bg-transparent sm:absolute sm:inset-0 sm:overflow-hidden">
        <!-- Header -->
        <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
            <div class="flex shrink-0">
                <!-- Title -->
                <!--<div class="text-3xl font-extrabold tracking-tight">Calidad de Censos</div> -->
                <!-- Search -->
                <mat-form-field class="fuse-mat-dense fuse-mat-rounded min-w-64" subscriptSizing="dynamic">
                    <mat-icon class="icon-size-5" matPrefix svgIcon="heroicons_solid:magnifying-glass"></mat-icon>
                    <input matInput placeholder="Buscar" autocomplete="off" (input)="applyFilter($event.target.value)" />
                </mat-form-field>
            </div>
            <!-- Actions -->
            <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
                <button mat-stroked-button color="primary" (click)="sidenav.toggle()" matTooltip="Mostrar filtros">
                    <mat-icon svgIcon="filter_list"></mat-icon>
                    <span>Filtrar por</span>
                </button>
            </div>
        </div>
  
        <!-- Main Content (Table and Paginator) -->
        <div class="flex flex-auto overflow-hidden flex-col">
            <div class="container mt-0 flex-auto flex-col overflow-x-auto">
                <div class="sticky top-0 z-10 bg-gray-100 dark:bg-gray-900">
                    <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table [dataSource]="dataSource" matSort>

                        <ng-container matColumnDef="det" >
                            <th mat-header-cell *matHeaderCellDef class="pr-0 pl-0"></th>
                            <td mat-cell *matCellDef="let element" class="pr-0 pl-0" style="width: 1px">
                            <button mat-icon-button color="primary" (click)="expandedElement = expandedElement === element ? null : element; this.openDetail(element)">
                                <i *ngIf="expandedElement !== element" matTooltip="{{'TRANSLATE.DETAIL_ON'| translate}}" class="fas fa-chevron-right"></i>
                                <i *ngIf="expandedElement === element" matTooltip="{{'TRANSLATE.DETAIL_OFF' | translate}}" class="fas fa-chevron-down"></i>
                            </button>
                            </td>
                        </ng-container>
        
                        <ng-container matColumnDef="routeCode">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Ruta</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="text-content">
                                    <b>{{element.routeCode}}</b><br>
                                    <span class="font-descrip"> {{element.routeName}}</span>
                                </div>
                            </td>
                        </ng-container>
        
                        <ng-container matColumnDef="userCode">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Vendedor</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="text-content">
                                    <b>{{element.userCode}}</b><br>
                                    <span class="font-descrip"> {{element.userName}}</span>
                                </div>
                            </td>
                        </ng-container>
        
                        <ng-container matColumnDef="nameDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Día</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="text-content">
                                    {{element.nameDate}}
                                </div>
                            </td>
                        </ng-container>
        
                        <ng-container matColumnDef="executionDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="text-content">
                                    {{element.executionDate}}
                                </div>
                            </td>
                        </ng-container>
        
                        <ng-container matColumnDef="totalVisit">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Visitas a realizar</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="text-content">
                                    {{element.totalVisit}}
                                </div>
                            </td>
                        </ng-container>
        
                        <ng-container matColumnDef="visitCustomer">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Visitas Realizadas</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="text-content">
                                    {{element.visitCustomer}}
                                </div>
                            </td>
                        </ng-container>
        
        
                        <ng-container matColumnDef="totalOnRoute">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Visitas con Venta </th>
                            <td mat-cell *matCellDef="let element">
                                <div class="text-content">
                                    {{element.totalVisit}}
                                </div>
                            </td>
                        </ng-container>
        
                        <ng-container matColumnDef="totalOffRoute">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Visitas Fuera de Frecuencia</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="text-content">
                                    {{element.outFrecuency}}
                                </div>
                            </td>
                        </ng-container>
        
                        <ng-container matColumnDef="visitNoCustomer">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Clientes no Visitados</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="text-content"><!--| number : '1.2-2'}-->
                                    {{element.visitNoCustomer}}
                                </div>
                            </td>
                        </ng-container>
        
                        <ng-container matColumnDef="visitTotalC">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Total de Visitas</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="text-content">
                                    {{element.visitTotalC}}
                                </div>
                            </td>
                        </ng-container>
        
                        <ng-container matColumnDef="qualityCensus">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Calidad Censo</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="text-content">
                                    {{element.qualityCensus | number : '1.2-2'}} %
                                </div>
                            </td>
                        </ng-container>
        
                        <ng-container matColumnDef="totalSale">
                            <th mat-header-cell *matHeaderCellDef>Factura Generadas</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="text-content">
                                    {{element.totalSale}}
                                </div>
                            </td>
                        </ng-container> 
        
                        <ng-container matColumnDef="invoiceNoCustomer">
                            <th mat-header-cell *matHeaderCellDef>Clientes no Facturados</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="text-content">
                                    {{element.invoiceNoCustomer}}
                                </div>
                            </td>
                        </ng-container> 
        
                        <ng-container matColumnDef="totalFinalConsumer">
                            <th mat-header-cell *matHeaderCellDef>Facturas Consumidor Final</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="text-content">
                                    {{element.totalFinalConsumer}}
                                </div>
                            </td>
                        </ng-container>
                        
                        <ng-container matColumnDef="totalEventualClient">
                            <th mat-header-cell *matHeaderCellDef>Facturas Cliente Eventual</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="text-content">
                                    {{element.totalEventualClient}}
                                </div>
                            </td>
                        </ng-container>
                        
                        <!-- Header Row -->
                        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>            
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b"></tr>
                    </table>
                </div>
                <div *ngIf="this.dataSource.data.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">Lo sentimos, no hay registros para mostrar.
                </div>
            </div>
    
            <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
                <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
                [pageIndex]="pageIndex" [pageSize]="pageSize" (page)="changePage($event)"></mat-paginator>
            </div>
        </div>
    </div>

    <!-- Filtros -->
    <mat-sidenav #sidenav mode="side" position="end" class="mat-sidenav-content p-0" closed>
        <div class="flex items-center justify-between bg-blue-950 text-white p-4">
            <mat-icon svgIcon="filter_list" class="text-white mr-2 w-4 h-4"></mat-icon>
            <h2 class="text-current text-lg font-bold">Filtros</h2>
            <button mat-icon-button class="ml-auto" (click)="sidenav.close()" matTooltip="Cerrar">
                <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </button>
        </div>

        <div class="mt-6 px-4">
            <mat-form-field class="w-full">
                <mat-label>Desde</mat-label>
                <input matInput [matDatepicker]="dateini" [(ngModel)]="filter.dateini">
                <mat-datepicker-toggle matIconSuffix [for]="dateini"></mat-datepicker-toggle>
                <mat-datepicker #dateini></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="w-full">
                <mat-label>Hasta</mat-label>
                <input matInput [matDatepicker]="dateend" [(ngModel)]="filter.dateend">
                <mat-datepicker-toggle matIconSuffix [for]="dateend"></mat-datepicker-toggle>
                <mat-datepicker #dateend></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="flex justify-between mt-4 px-4">
            <button mat-button class="align-left text-gray-700 border border-gray-300" (click)="onClearFilter()">Limpiar</button>
            <button mat-raised-button class="ml-auto bg-blue-950 text-white" (click)="onFilter()">Aplicar</button>
        </div>
    </mat-sidenav>
</mat-sidenav-container>